<template>
  <div class="not-found">
    <div class="not-found-content">
      <div class="not-found-icon">
        <i class="el-icon-warning-outline"></i>
      </div>
      <h1 class="not-found-title">404</h1>
      <p class="not-found-desc">抱歉，您访问的页面不存在</p>
      <div class="not-found-actions">
        <el-button type="primary" @click="goHome">返回首页</el-button>
        <el-button @click="goBack">返回上页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goHome() {
      this.$router.push('/')
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.not-found {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.not-found-content {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.not-found-icon {
  font-size: 64px;
  color: #409eff;
  margin-bottom: 20px;
}

.not-found-title {
  font-size: 72px;
  color: #303133;
  margin: 0 0 20px 0;
  font-weight: bold;
}

.not-found-desc {
  font-size: 16px;
  color: #606266;
  margin: 0 0 30px 0;
}

.not-found-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
}
</style>
